export { default } from './SliderInput';
